export enum VehicleLockTypeId {
  None = 0,
  Purchase = 1,
  WIP = 2,
  User = 3
}

export enum VehicleLockTypeKey {
  None = 'None',
  Purchase = 'Purchase',
  WIP = 'WIP',
  User = 'User'
}
